// Decodes the JWT payload the same way ScheduleView.vue already does, without
// pulling in a JWT-decoding library for one field.
function decodeTokenPayload(token: string): Record<string, unknown> | null {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
}

export function getCurrentUserRole(): string | null {
  const token = localStorage.getItem("token");
  if (!token) {
    return null;
  }

  const payload = decodeTokenPayload(token);
  // "UserType" is set verbatim from the DB role name and isn't shortened by
  // ASP.NET's outbound claim-type mapping the way the "role" claim is.
  return (payload?.UserType as string) ?? null;
}

export function isBoss(): boolean {
  return getCurrentUserRole() === "Boss";
}

export function isAdmin(): boolean {
  return getCurrentUserRole() === "admin";
}
